import Proj1 from "../assets/proj1.png";
import Proj2 from "../assets/proj2.png";
import Proj3 from "../assets/proj3.png";
import Proj4 from "../assets/proj4.png";
import Proj5 from "../assets/proj5.png";
import Proj6 from "../assets/proj6.png";

export const ProjectList = [
  {
    name: "Todo List",
    image: Proj1,
    skills: "JavaScript,HTML,CSS",
  },
  {
    name: "Quick Quiz",
    image: Proj2,
    skills: "JavaScript,HTML,CSS",
  },
  {
    name: "Mein new_portfolio",
    image: Proj3,
    skills: "React,JavaScript,HTML,CSS",
  },
  {
    name: "Online Calculator",
    image: Proj4,
    skills: "Open UI5, JavaScript, View.xml, Manifest.json",
  },
  {
    name: "Sign up and Login",
    image: Proj5,
    skills: "JavaScript,HTML,CSS",
  },
  {
    name: "Passwort Prüfer",
    image: Proj6,
    skills: "JavaScript,HTML,CSS",
  },
];
